/* Fuerto — detail produktu: krátký lead, trust pruh, lepivé CTA na mobilu */
(function () {
  var SVG_RETURN = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M3 12a9 9 0 1 0 3-6.7"/><path d="M3 4v5h5"/></svg>';
  var SVG_HELP = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15a2 2 0 0 1-2 2H8l-5 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>';

  function box(svg, title, desc) {
    var d = document.createElement('div');
    d.className = 't';
    d.innerHTML = '<span class="ti">' + svg + '</span><div><div class="tt"></div><div class="td"></div></div>';
    d.querySelector('.tt').textContent = title;
    d.querySelector('.td').textContent = desc;
    return d;
  }

  /* Sekce vypisuje celý popis produktu přes strip_html, takže se odrážky
     slijí do jednoho dlouhého odstavce. Necháme nahoře jen první větu;
     odrážky zůstávají v rozbalovacím „Popis produktu“. */
  function lead() {
    var p = document.querySelector('.pdp .pdesc');
    if (!p) return;
    var body = document.querySelector('.acc .acc-body');
    var first = body && body.querySelector('p');
    var t = first && first.textContent.trim();
    if (t) p.textContent = t;
  }

  /* Trust pruh: přesun pod tlačítko a doplnění na čtyři položky. */
  function trustbar() {
    var pdp = document.querySelector('.pdp');
    if (!pdp) return;
    var bar = pdp.querySelector('.trust2');
    var note = pdp.querySelector('.ship-note');
    if (!bar || !note || bar.classList.contains('fz-trust-ready')) return;

    if (bar.querySelectorAll('.t').length < 3) {
      bar.appendChild(box(SVG_RETURN, 'Vrácení do 30 dnů', 'Nenošené zboží bez udání důvodu.'));
      bar.appendChild(box(SVG_HELP, 'Poradíme ti', 'Po–Pá 9–17 h, info@fuerto.cz'));
    }
    note.parentNode.insertBefore(bar, note.nextSibling);
    bar.classList.add('fz-trust-ready');
  }

  /* Lepivé CTA na mobilu */
  function sticky() {
    /* nad 900 px lištu schová CSS — bez kontroly šířky funguje i po otočení telefonu */
    var pdp = document.querySelector('.pdp');
    if (!pdp) return;
    var atc = pdp.querySelector('.atc');
    if (!atc || document.querySelector('.fz-sticky-atc')) return;

    var priceEl = pdp.querySelector('.price');
    var titleEl = document.querySelector('.pdp-title');

    var wrap = document.createElement('div');
    wrap.className = 'fz-sticky-atc';

    var info = document.createElement('div');
    info.className = 'fz-sa-info';
    var name = document.createElement('span');
    name.className = 'fz-sa-name';
    name.textContent = titleEl ? titleEl.textContent.trim() : '';
    var price = document.createElement('span');
    price.className = 'fz-sa-price';
    price.textContent = priceEl ? priceEl.textContent.trim() : '';
    info.appendChild(name);
    info.appendChild(price);

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'fz-sa-btn';
    btn.textContent = 'Přidat do košíku';
    if (atc.disabled) { btn.disabled = true; btn.textContent = 'Vyprodáno'; }
    btn.addEventListener('click', function () { atc.click(); });

    wrap.appendChild(info);
    wrap.appendChild(btn);
    document.body.appendChild(wrap);
    /* místo pro lištu je rezervované napořád — přepínání odsazení posouvalo konec stránky */
    document.body.classList.add('fz-sticky-ready');

    var show = function (on) {
      wrap.classList.toggle('is-on', on);
      document.body.classList.toggle('fz-has-sticky', on);
    };

    if ('IntersectionObserver' in window) {
      /* -80 px = výška lišty: schová se, až je hlavní tlačítko opravdu nad ní (dřív problikávala) */
      new IntersectionObserver(function (e) { show(!e[0].isIntersecting); },
        { rootMargin: '0px 0px -80px 0px' }).observe(atc);
    } else {
      window.addEventListener('scroll', function () {
        show(atc.getBoundingClientRect().bottom < 0);
      }, { passive: true });
    }
  }

  /* lead() a trustbar() vypnuto 7. 10. 2026: úvod i výhody vykresluje přímo šablona,
     přesouvání po načtení dělalo poskočení stránky. */
  function init() { sticky(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
